/*
 * Palladium
 */
function factory({ window, document, thn }) {
    const engine = {};
    engine.isUserLogged = function isUserLogged(ctx) {
        return !!thn.dataLayerHelper.get('idUser');
    };
    return engine;
}

export { factory };
